import React from "react";
import { Container, Row, Col, Form, Label, Input, Button } from "reactstrap";




class AboutContent extends React.Component {
  render() {

    return (
      <div className="about-content" id="AboutJointly">
        <Container>
          <Row>
            <Col md={{ size: 8, offset: 2 }} sm={12} >
              <h5>Jointly is a platform that empowers couples to manage money better, together.  <br /><br /></h5>

              <p>
              People are marrying later and cohabitating earlier, which means we’re bringing more financial baggage to our shared households. Studies show that money fights are a major source of relationship stress and often, a big factor in break-ups and divorce.
              </p>
              <p>
              At Jointly, we get it. Managing shared finances has been stressful in our own relationships, and existing tools are almost entirely focused on the individual. We founded Jointly because we want to do better for ourselves and for millions of couples that we know are similarly struggling.
              </p>
              <p>
              We believe that personal finance tools are a means to an end—to living the life you want. Jointly is here to guide the conversation and arm you with the resources to make this collaboration fun.
              </p>
              <p>
              We believe—and research shows—that when it comes to financial decision-making, two heads are better than one. We’ll provide the app. You provide the hopes and dreams! 
              </p>
              <p>
              As we build our platform, we’ll be sharing stories. Some are our own, and some are stories that others have generously shared with us. Join the conversation. Help us spread the word about doing it Jointly! 
              </p>

            </Col>   
          </Row>      
        </Container>
      </div>
    );
  }
}

export default AboutContent;



// WEBPACK FOOTER //
// ./src/components/About/About_Content.jsx